<div
  class="app-stepper"
  [ngClass]="[customClass, 'app-stepper--align-' + align]"
  [style.width]="width || null"
  [style.maxWidth]="maxWidth || null"
>
  <div class="app-stepper__container">
    <div
      *ngFor="let step of normalizedSteps; let i = index; let last = last; let first = first; trackBy: trackByStep"
      class="app-stepper__step"
      [ngClass]="{
        'app-stepper__step--active': isStepActive(i),
        'app-stepper__step--completed': isStepCompleted(i),
        'app-stepper__step--disabled': step.disabled || !canNavigateTo(i),
        'app-stepper__step--clickable': !step.disabled && canNavigateTo(i)
      }"
      (click)="onStepSelect(i)"
    >
      <!-- Connector Line (Left side for steps > 0) -->
      <div
        *ngIf="!first"
        class="app-stepper__connector app-stepper__connector--left"
        [ngClass]="{
          'app-stepper__connector--completed': isConnectorCompleted(i - 1)
        }"
      ></div>

      <!-- Connector Line (Right side for steps < last) -->
      <div
        *ngIf="!last"
        class="app-stepper__connector app-stepper__connector--right"
        [ngClass]="{
          'app-stepper__connector--completed': isConnectorCompleted(i)
        }"
      ></div>

      <!-- Step Circle Badge (1, 2, 3...) -->
      <div
        class="app-step-icon"
        [ngClass]="{
          'app-step-icon--active': isStepActive(i),
          'app-step-icon--completed': isStepCompleted(i)
        }"
        [style.backgroundColor]="isStepHighlighted(i) ? activeColor : null"
      >
        <span>{{ i + 1 }}</span>
      </div>

      <!-- Step Label -->
      <div class="app-step-label-container">
        <span
          class="app-step-label"
          [ngClass]="{
            'app-step-label--active': isStepActive(i),
            'app-step-label--completed': isStepCompleted(i)
          }"
        >
          {{ step.label }}
        </span>
        <span *ngIf="step.description" class="app-step-description">
          {{ step.description }}
        </span>
      </div>
    </div>
  </div>
</div>
